import { Environment } from '@wm-libs/core';

export const environment: Environment = {
  name: 'development',
  // api
  poolApi: 'https://stage-pool-api.wemine.tech/api',
  mmsApi: 'https://stage.wemine.tech/api',

  // domains
  techDomain: 'https://new-stage.wemine.tech',
  techMmsDomain: 'https://new-stage-mms.wemine.tech',
  techPoolDomain: 'https://new-stage-pool.wemine.tech',
  adminDomain: 'https://new-stage-admin.wemine.tech',

  // langs
  langs: ['en', 'ru'],
  defaultLang: 'en',

  // translate api
  translationApiUrl: 'https://translations-api.ataix.com/api',
};
